import { API } from 'aws-amplify';
import { getContact } from '../../graphql/queries';

export const getContactDetails = (familyId, contactId) =>  {
    return API.graphql({
      query: getContact,
      variables: { contactId: contactId, familyId: familyId }
    });
}